<template>
  <v-container>
    <v-layout row wrap mb-4>
      <v-flex class="text-xs-right">
        <v-btn class="k-orange-linear mr-0" @click="createStage">
          Crear etapa de compromiso
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <p-stages-list
          :stages="pStages"
          @select-stage="selectedPStageId = $event.id"
          @commute-stage="commuteStage"
          @edit-stage="editStage"
          @delete-stage="deleteStage"
          @commute-filter="commuteFilter"
          @create-filter="createFilter"
          @edit-filter="editFilter"
          @delete-filter="deleteFilter" />
      </v-flex>
    </v-layout>
    <p-stage-modal
      :show="pStageModal"
      :p-stage="selectedPStage"
      @created="$emit('p-stage-created', $event)"
      @updated="$emit('p-stage-updated', $event)"
      @close="pStageModal = false"/>
    <p-filter-modal
      :show="pFilterModal"
      :p-stage="selectedPStage"
      :p-filter="selectedPFilter"
      @created="$emit('p-filter-created', selectedPStage, $event)"
      @updated="$emit('p-filter-updated', selectedPStage, $event)"
      @close="pFilterModal = false" />
    <delete-dialog
      :show="deleteModal"
      :url="deleteUrl"
      :message="deleteMessage"
      @deleted="deletedEvt"
      @close="deleteModal = false"/>
  </v-container>
</template>

<script>
import _ from 'lodash';
import PStageModal from '@/components/CollectWorkflows/Detail/PaymentPromiseTree/PStageModal';
import PStagesList from '@/components/CollectWorkflows/Detail/PaymentPromiseTree/PStagesList';
import PFilterModal from '@/components/CollectWorkflows/Detail/PaymentPromiseTree/PFilterModal';
import DeleteDialog from '@/components/global/DeleteDialog2';

export default {
  props: {
    workflow: {
      type: Object,
      required: true,
    },
    pStages: {
      type: Array,
      required: true,
    },
  },
  components: {
    PStageModal,
    PStagesList,
    PFilterModal,
    DeleteDialog,
  },
  data() {
    return {
      pStageModal: false,
      pFilterModal: false,
      selectedPStageId: 0,
      selectedPFilter: {},
      deleteModal: false,
      deleteType: 'stage',
    };
  },
  computed: {
    selectedPStage() {
      return this.pStages.find(item => item.id === this.selectedPStageId) || {};
    },
    deleteUrl() {
      let url = '';
      if (this.deleteType === 'stage') {
        url = `payment_p_stages/${this.selectedPStage.id}`;
      } else {
        url = `payment_p_filters/${this.selectedPFilter.id}`;
      }
      return url;
    },
    deleteMessage() {
      let message = '';
      if (this.deleteType === 'stage') {
        message = `¿Esta seguro de que desea eliminar la etapa ${this.selectedPStage.days_off} días antes del compromiso? Se borraran todos los filtros y plantillas asociadas. Esta acción es irreversible`;
      } else {
        message = `¿Esta seguro de que desea eliminar el filtro ${this.selectedPFilter.name}? Se borraran todas las plantillas asociadas. Esta acción es irreversible`;
      }
      return message;
    },
  },
  methods: {
    createStage() {
      this.selectedPStageId = 0;
      this.pStageModal = true;
    },
    editStage(stage) {
      this.selectedPStageId = stage.id;
      this.pStageModal = true;
    },
    commuteStage(stage) {
      this.axios.patch(`payment_p_stages/${stage.id}`, {
        status: stage.status === 1 ? 0 : 1,
      }).then((response) => {
        this.$emit('p-stage-updated', response.data);
      }).catch(() => {});
    },
    deleteStage(stage) {
      this.selectedPStageId = stage.id;
      this.deleteType = 'stage';
      this.deleteModal = true;
    },
    commuteFilter(filter) {
      this.axios.patch(`payment_p_filters/${filter.id}`, {
        status: filter.status === 1 ? 0 : 1,
      }).then((response) => {
        this.$emit('p-filter-updated', this.selectedPStage, response.data);
      }).catch(() => {});
    },
    createFilter(stage) {
      this.selectedPStageId = stage.id;
      this.selectedPFilter = {};
      this.pFilterModal = true;
    },
    editFilter(filter) {
      const template = filter.template || {};
      const tmp = {
        ..._.pick(filter, [
          'id',
          'name',
          'broken_promises',
          'status',
          'send_email',
          'send_sms',
          'send_ivr',
          'send_human',
        ]),
        ..._.pick(template, [
          'company_email_id',
          'subject',
          'email',
          'sms',
          'ivr',
          'human',
        ]),
        template_id: template.id,
        filters: JSON.parse(filter.filters || '[]'),
      };
      this.selectedPFilter = tmp;
      this.pFilterModal = true;
    },
    deleteFilter(filter) {
      this.selectedPFilter = filter;
      this.deleteType = 'filter';
      this.deleteModal = true;
    },
    deletedEvt() {
      this.deleteModal = false;
      this.$emit(`p-${this.deleteType}-deleted`, ...[
        this.selectedPStage,
        ...this.deleteType === 'filter' && [
          this.selectedPFilter,
        ],
      ]);
      if (this.deleteType === 'stage') {
        this.selectedPStageId = 0;
      } else {
        this.selectedPFilter = {};
      }
    },
  },
  watch: {
    pFilterModal() {
      if (!this.pFilterModal) {
        this.selectedPFilter = {};
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/CollectWorkflows/Detail/PaymentPromiseTree/Index.vue